import { render, staticRenderFns } from "./ErrorResidentialBusiness.vue?vue&type=template&id=d7bc3ff8&"
import script from "./ErrorResidentialBusiness.vue?vue&type=script&lang=js&"
export * from "./ErrorResidentialBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports